import { Checkbox } from '@mantine/core';

import { useFormsListContext } from '../../context';
import { useFormRowContext } from './FormRowContext';

export const CheckboxCell = () => {
  const { form } = useFormRowContext();
  const { isFormMassActionsSelected, toggleFormMassActionsSelected } =
    useFormsListContext();
  const isChecked = isFormMassActionsSelected(form.id);

  return (
    <td>
      <Checkbox
        sx={{ marginBottom: 0 }}
        checked={isChecked}
        onChange={() => toggleFormMassActionsSelected(form)}
        onClick={e => e.stopPropagation()}
      />
    </td>
  );
};
